export const updateByPath = (data, path, payload, shouldAssign = true) => {
    const referenceToInitialData = data;

    let stack = path.split('.');
    let current;

    while (stack.length > 1) {
        data = data[stack.shift()];
        current = data[stack];
    }

    data[stack.shift()] = shouldAssign
        ? payload
        : {
            ...current,
            ...payload
        };

    return referenceToInitialData;
};